// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1cESM","overflowing":"ReadFullNote_overflowing__KGM5X"};